import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function ConsentIframeModal({
  open,
  title,
  description,
  iframeSrc,
  iframeRef,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {description && <Typography variant="body2">{description}</Typography>}
        {iframeSrc ? (
          <iframe
            title={title || 'Consent document'}
            src={iframeSrc}
            ref={iframeRef}
            referrerPolicy="no-referrer"
            style={{ width: '100%', minHeight: '70vh', border: 0 }}
          />
        ) : (
          <Typography variant="body2">Loading consent document...</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConsentIframeModal;
